// SouthIndianChart.js - South Indian Birth Chart
import React from "react";

const RASI_ORDER = [0,1,2,3,4,5,6,7,8,9,10,11];

// South Indian chart house layout (fixed rasi positions)
// Row 0: Pisces(12), Aries(1), Taurus(2), Gemini(3)
// Row 1: Aquarius(11), [TL], [TR], Cancer(4)
// Row 2: Capricorn(10), [BL], [BR], Leo(5)
// Row 3: Sagittarius(9), Scorpio(8), Libra(7), Virgo(6)

const HOUSE_RASI = [
  [11,0,1,2],
  [10,-1,-1,3],
  [9,-1,-1,4],
  [8,7,6,5]
];

const RASI_TA = ["மேஷம்","ரிஷபம்","மிதுனம்","கடகம்","சிம்மம்","கன்னி","துலாம்","விருச்சிகம்","தனுசு","மகரம்","கும்பம்","மீனம்"];
const RASI_EN = ["Aries","Taurus","Gemini","Cancer","Leo","Virgo","Libra","Scorpio","Sagittarius","Capricorn","Aquarius","Pisces"];
const RASI_NUM = ["1","2","3","4","5","6","7","8","9","10","11","12"];

const PLANET_SHORT_TA = {
  "Sun":"சூ",
  "Moon":"சந்",
  "Mars":"செவ்",
  "Mercury":"பு",
  "Jupiter":"கு",
  "Venus":"சுக்",
  "Saturn":"சனி",
  "Rahu":"ரா",
  "Ketu":"கே"
};

export default function SouthIndianChart({ result, lang = "ta" }) {
  if (!result || !result.planet_positions) return null;

  const planets = result.planet_positions;
  const lagnam_idx = result.lagnam_idx || 0;

  // Group planets by rasi
  const rasiPlanets = {};
  for (let i = 0; i < 12; i++) rasiPlanets[i] = [];

  // Add Lagnam
  rasiPlanets[lagnam_idx].push({ name: "Lag", name_ta: "லக்", isLag: true });

  Object.entries(planets).forEach(([pname, pdata]) => {
    rasiPlanets[pdata.rasi].push({
      name: pname,
      name_ta: PLANET_SHORT_TA[pname] || pname,
      isLag: false
    });
  });

  const size = typeof window !== "undefined" && window.innerWidth < 480 ? 320 : typeof window !== "undefined" && window.innerWidth < 768 ? 360 : 400;
  const cell = size / 4;
  const innerCell = cell * 1.2;

  const getCellRect = (row, col) => {
    if (row === 1 && col === 1) return { x: cell, y: cell, w: cell * 2, h: cell * 2, isCenter: true };
    if (row === 1 && col === 2) return null;
    if (row === 2 && col === 1) return null;
    if (row === 2 && col === 2) return null;
    return { x: col * cell, y: row * cell, w: cell, h: cell, isCenter: false };
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "8px", width: "100%", boxSizing: "border-box" }}>
      <div style={{ fontSize: "14px", fontWeight: 700, color: "#f6d365", marginBottom: "12px" }}>
        {lang === "ta" ? "ஜனன குணப்படம் - தென்னிந்திய வடிவம்" : "Birth Chart - South Indian Style"}
      </div>
      <svg width="100%" height="100%" viewBox={`0 0 ${size} ${size}`} style={{ border: "2px solid rgba(246,211,101,0.4)", borderRadius: "4px", background: "#1a1035" }}>
        {HOUSE_RASI.map((row, ri) =>
          row.map((rasi, ci) => {
            if (rasi === -1) return null;
            const rect = getCellRect(ri, ci);
            if (!rect || rect.isCenter) return null;
            const planetsInRasi = rasiPlanets[rasi] || [];
            const isLagnamHouse = planetsInRasi.some(p => p.isLag);

            return (
              <g key={`${ri}-${ci}`}>
                <rect x={rect.x} y={rect.y} width={rect.w} height={rect.h}
                  fill={isLagnamHouse ? "rgba(124,58,237,0.15)" : "rgba(255,255,255,0.02)"}
                  stroke="rgba(246,211,101,0.3)" strokeWidth="1" />
                {/* Rasi number */}
                <text x={rect.x + 4} y={rect.y + 13} fontSize="10" fill="rgba(246,211,101,0.5)" fontFamily="sans-serif">{RASI_NUM[rasi]}</text>
                {/* Rasi name */}
                <text x={rect.x + rect.w/2} y={rect.y + rect.h/2 - 8} fontSize="9" fill="rgba(200,180,255,0.7)" textAnchor="middle" fontFamily="sans-serif">
                  {lang === "ta" ? RASI_TA[rasi] : RASI_EN[rasi]}
                </text>
                {/* Planets */}
                {planetsInRasi.filter(p => !p.isLag).map((p, pi) => (
                  <text key={pi} x={rect.x + rect.w/2} y={rect.y + rect.h/2 + 8 + pi*12}
                    fontSize="10" fill={p.isLag ? "#ff0" : "#10B981"} textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">
                    {lang === "ta" ? p.name_ta : p.name}
                  </text>
                ))}
                {/* Lagnam marker */}
                {isLagnamHouse && (
                  <text x={rect.x + rect.w - 4} y={rect.y + 13} fontSize="9" fill="#f6d365" textAnchor="end" fontFamily="sans-serif" fontWeight="bold">Lag</text>
                )}
              </g>
            );
          })
        )}
        {/* Center box */}
        <rect x={cell} y={cell} width={cell*2} height={cell*2} fill="rgba(15,12,41,0.8)" stroke="rgba(246,211,101,0.3)" strokeWidth="1" />
        <text x={size/2} y={size/2 - 20} fontSize="11" fill="#f6d365" textAnchor="middle" fontFamily="sans-serif" fontWeight="bold">
          {result.name}
        </text>
        <text x={size/2} y={size/2} fontSize="10" fill="#94a3b8" textAnchor="middle" fontFamily="sans-serif">
          {result.dob}
        </text>
        <text x={size/2} y={size/2 + 16} fontSize="10" fill="#94a3b8" textAnchor="middle" fontFamily="sans-serif">
          {result.time}
        </text>
        <text x={size/2} y={size/2 + 32} fontSize="9" fill="#64748b" textAnchor="middle" fontFamily="sans-serif">
          {result.place}
        </text>
      </svg>
      {/* Legend */}
      <div style={{ display: "flex", gap: "16px", marginTop: "12px", fontSize: "12px" }}>
        <span style={{ color: "#10B981" }}>&#9632; {lang === "ta" ? "கிரகங்கள்" : "Planets"}</span>
        <span style={{ color: "#f6d365" }}>&#9632; {lang === "ta" ? "லக்னம்" : "Lagnam"}</span>
        <span style={{ color: "rgba(200,180,255,0.7)" }}>&#9632; {lang === "ta" ? "ராசி" : "Rasi"}</span>
      </div>
    </div>
  );
}
